import React from "react";
import { useResponsiveStyles } from "../../../../styles/useResponsiveStyles";

export const ContactInfo = ({ data }) => {
    const { getFontSize } = useResponsiveStyles();

    return (
        <div className="p-2 space-y-4">
            <div>
                <div
                    className=" text-[#4C4E64] font-semibold"
                    style={getFontSize("body1")}
                >
                    Relationship Manager
                </div>
                <div className="flex justify-between items-center mt-1">
                    <span
                        className=" text-gray-600"
                        style={getFontSize("body1")}
                    >
                        {data?.current_year_data?.primary_sales_name}
                    </span>
                    <a
                        href={`tel:${data?.current_year_data?.primary_sales_contact}`}
                        className="text-red-500"
                        style={getFontSize("body1")}
                    >
                        {data?.current_year_data?.primary_sales_contact &&
                        data?.current_year_data?.primary_sales_contact ===
                            "null"
                            ? ""
                            : data?.current_year_data?.primary_sales_contact}
                    </a>
                </div>
                <div className="flex justify-between items-center mt-1">
                    <span
                        className=" text-gray-600"
                        style={getFontSize("body1")}
                    >
                        {data?.current_year_data?.secondary_sales_name}
                    </span>
                    <a
                        href={`tel:${data?.current_year_data?.secondary_sales_contact}`}
                        className="text-red-500"
                        style={getFontSize("body1")}
                    >
                        {data?.current_year_data?.secondary_sales_contact &&
                        data?.current_year_data?.secondary_sales_contact ===
                            "null"
                            ? ""
                            : data?.current_year_data?.secondary_sales_contact}
                    </a>
                </div>
            </div>
            <div>
                <div
                    className=" text-[#4C4E64] font-semibold"
                    style={getFontSize("body1")}
                >
                    Trader Connect
                </div>
                <div className="flex justify-between items-center mt-1 gap-2">
                    <span
                        className="text-gray-600"
                        style={getFontSize("body1")}
                    >
                        {data?.current_year_data?.trader_name}
                    </span>
                    <a
                        href={`tel:${data?.current_year_data?.trader_contact}`}
                        className="text-red-500"
                        style={getFontSize("body1")}
                    >
                        {data?.current_year_data?.trader_contact &&
                        data?.current_year_data?.trader_contact === "null"
                            ? ""
                            : data?.current_year_data?.trader_contact}
                    </a>
                </div>
                <div className="flex justify-between items-center mt-1 gap-2">
                    <span
                        className=" text-gray-600"
                        style={getFontSize("body1")}
                    >
                        {data?.current_year_data?.secondary_trader_name}
                    </span>
                    <a
                        href={`tel:${data?.current_year_data?.secondary_trader_contact}`}
                        className="text-red-500"
                        style={getFontSize("body1")}
                    >
                        {data?.current_year_data?.secondary_trader_contact &&
                        data?.current_year_data?.secondary_trader_contact ===
                            "null"
                            ? ""
                            : data?.current_year_data?.secondary_trader_contact}
                    </a>
                </div>
            </div>
        </div>
    );
};
